import React from 'react';
import * as css from './leadItem.css';
import _ from 'lodash';

function LeadItem({data, index, t, dataKeys}){
    return (
        <css.leadItem key={index}>
        <css.leadHeader>
            <css.leadName>{data.name}</css.leadName>
            {_.has(data, 'status') && <css.statusIndicator $status={data.status} />}
        </css.leadHeader>
        
        <css.leadStats>
            {dataKeys.map((key, index) => (
               _.has(data, key.key) &&
                <React.Fragment key={key.key+index}>
                    <css.statItem>
                        {t(key.label)}: {data[key.key]}{key.suffix}
                    </css.statItem>
                </React.Fragment>
            ))}
        </css.leadStats>
    </css.leadItem>
    );
}   
export default LeadItem;